module.exports = {
      id: "comm-lifestyle-usage",
      viewBox: "0 0 294 59.387",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#comm-lifestyle",
      toString: function () {
        return this.url;
      }
    }